import { getEnvVar } from "../../utilities/appEnvVariables";
import { ILogger, buildAppLogger, LoggerType } from "@dcl-ue/app-logger";

let appLogger;

const initAppLogger = (): ILogger => {
  let loggerType = getEnvVar("loggerType") as LoggerType;
  const config =
    loggerType === "client" ? {} : { key: getEnvVar("appDynamicsKey") };

  const logger = buildAppLogger(loggerType, config as any);
  return logger;
};

export const getAppLogger = () => {
  if (!appLogger) {
    appLogger = initAppLogger();
  }

  return appLogger;
};
